/**
 *
 * InfoControl
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import RouteInfo from '../RoutePath/RouteInfo';
import ClubInfo from '../ClubMarkers/ClubInfo';

function InfoControl(props) {
  const { params, workingRoute } = props;
  if (workingRoute && workingRoute.legs) {
    return null;
  }
  if (params.routeId) {
    return <RouteInfo routeId={Number(params.routeId)} />;
  }
  if (params.clubId) {
    return (
      <ClubInfo
        clubId={Number(params.clubId)}
        locationId={Number(params.locationId)}
      />
    );
  }
  return null;
}

InfoControl.propTypes = {
  params: PropTypes.object.isRequired,
  workingRoute: PropTypes.object,
};

export default InfoControl;
